import { render } from "./good.vue?vue&type=template&id=463bec59&scoped=true"
import script from "./good.vue?vue&type=script&lang=js"
export * from "./good.vue?vue&type=script&lang=js"

import "./good.vue?vue&type=style&index=0&id=463bec59&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463bec59"]])

export default __exports__